import { SessionStorage } from '@ibe/services';
import dayjs from 'dayjs';

export const magnoliaUrl: string = process.env.MAGNOLIA_HOST ?? '';
export const apis = {
  base: magnoliaUrl + (process.env.MAGNOLIA_API_BASE ?? '/.rest'),
  templateAnnotations:
    magnoliaUrl + (process.env.MAGNOLIA_API_TEMPLATES ?? '/.rest/template-annotations/v1'),
  pages: magnoliaUrl + (process.env.MAGNOLIA_API_PAGES ?? '/.rest/delivery/pages/v1'),
  hotels: magnoliaUrl + (process.env.MAGNOLIA_API_HOTELS ?? '/.rest/delivery/hotels-endpoint'),
  destinations:
    magnoliaUrl +
    (process.env.MAGNOLIA_API_DESTINATIONS ?? '/.rest/delivery/destinations-endpoint'),
  config: magnoliaUrl + (process.env.MAGNOLIA_API_CONFIG ?? '/.rest/delivery/config/'),
  site: magnoliaUrl + (process.env.MAGNOLIA_API_SITE ?? '/.rest/site/v1'),
  translationsVersion: magnoliaUrl + '/.rest/translations/version'
};

export const stepSessionStorage = new SessionStorage<string>('ysn-step-session-storage');

export const scrollToAnchor = (id: string, window?: Window | null): void => {
  const anchorElement = window?.document?.getElementById(id);
  if (anchorElement) {
    const anchorPosition = anchorElement.getBoundingClientRect().top;
    const offset = anchorPosition + (window?.scrollY ?? 0);
    window?.scrollTo({ behavior: 'smooth', top: offset });
  }
};

export const logLevels = ['error', 'warn', 'debug', 'log', 'info', 'mute'] as const;
export type LogLevel = (typeof logLevels)[number];

export const logger =
  (type: LogLevel = 'log') =>
  (...values: (string | unknown)[]) => {
    const logLevel = process.env.LOG_LEVEL ?? 'log';
    const { debug, error, warn, log, info } = console;
    let logFn;
    switch (type) {
      case 'error':
        logFn =
          logLevel === 'error' ||
          logLevel === 'warn' ||
          logLevel === 'debug' ||
          logLevel === 'info' ||
          logLevel === 'log'
            ? error
            : undefined;
        break;
      case 'warn':
        logFn =
          logLevel === 'warn' || logLevel === 'debug' || logLevel === 'info' || logLevel === 'log'
            ? warn
            : undefined;
        break;
      case 'debug':
        logFn =
          logLevel === 'debug' || logLevel === 'info' || logLevel === 'log' ? debug : undefined;
        break;
      case 'info':
        logFn = logLevel === 'info' || logLevel === 'log' ? info : undefined;
        break;
      default:
        logFn = logLevel === 'log' ? log : undefined;
    }
    if (logFn) {
      logFn(`- ${dayjs().format('DD.MM.YYYY, HH:mm:ss:SSSZ[Z]')} --`, ...values);
    }
  };

const isClient = (): boolean => {
  return typeof window !== 'undefined';
};

export default isClient;
